// extracted by mini-css-extract-plugin
module.exports = {"treeWrapper":"SimulationResults_treeWrapper__MD8MZ","deviationWrapper":"SimulationResults_deviationWrapper__2LFuz"};